module.exports = __webpack_public_path__ + "img/ios-home-02.1c1d3da5.jpg";